// extracted by mini-css-extract-plugin
export default {"container":"SessionScreen_container__RWZfO","push":"SessionScreen_push__WX+GM"};